import { Accordion } from '@/components/ui/accordion'
import Loader from '@/components/ui/Loader'
import { fetcher } from 'api/swr'
import Divider from 'components/ui/Divider'
import { useUI } from 'Editor'
import { isDeletedComponent } from 'Editor/lib/visibleComponents'
import React, { useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import useSWR from 'swr'
import { jobMatchesLayer, useCptUploadStore } from '../BatchUpload/uploadQueue'
import BatchCoverBar from './BatchCoverBar'
import { useBatchSelectStore } from './batchSelectStore'
import { CptListDropZone } from './CptListDropZone'
import { CptsInDlc, CptsWithoutDlc, DefalutCpts } from './DefalutCpts'
import LayerPicker from './LayerPicker'
import RelatedSpineComponents from './RelatedSpineComponents'

export const LayerPanel = () => {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="shrink-0">
        <LayerPicker />
        <Divider />
      </div>
      {/* 普通组件 + 关联 Spine 共用一条滚动；拖拽区铺满剩余高度 */}
      <CptListDropZone className="min-h-0 flex-1 overflow-y-auto overscroll-contain">
        <CptInLayer />
        <RelatedSpineComponents />
      </CptListDropZone>
    </div>
  )
}

export default LayerPanel

const CptInLayer = () => {
  const { tid } = useParams('tid')
  const lid = useUI((state) => state.lid)
  const clearBatch = useBatchSelectStore((s) => s.clear)
  const { data, isLoading } = useSWR(['/components', { tid }], fetcher)
  const cpts = useMemo(() => {
    const live = (data ?? []).filter((cpt) => !isDeletedComponent(cpt))
    const inLayer =
      lid && lid !== 'draft'
        ? live.filter((cpt) => cpt.lid === lid)
        : live.filter((cpt) => cpt.lid === 'draft' || !cpt.lid)
    const numbered = inLayer.every(
      (cpt) => cpt.playIndex != null && Number.isFinite(Number(cpt.playIndex)),
    )
    if (!numbered) return inLayer
    return [...inLayer].sort(
      (a, b) =>
        Number(a.playIndex) - Number(b.playIndex) ||
        String(a.id).localeCompare(String(b.id)),
    )
  }, [data, lid])

  const [opens, setOpens] = useState([tid])

  const uploadOpenKey = useCptUploadStore((s) =>
    s.jobs
      .filter((job) => job.tid === tid && jobMatchesLayer(job, lid))
      .map((job) => job.dlc || 'withoutdlc')
      .sort()
      .join(','),
  )

  useEffect(() => {
    if (!uploadOpenKey) return
    const extra = uploadOpenKey.split(',').filter(Boolean)
    setOpens((prev) => [...new Set([...prev, tid, ...extra])])
  }, [uploadOpenKey, tid])

  // 切换层时清空多选，避免跨层误操作
  useEffect(() => {
    clearBatch()
  }, [lid, clearBatch])

  if (isLoading) return <Loader>Load cpts...</Loader>

  return (
    <div className="w-full">
      <BatchCoverBar cpts={cpts} />
      <Accordion
        type="multiple"
        value={opens}
        onValueChange={(value) => {
          value !== tid && setOpens([...value, tid])
        }}
      >
        <CptsWithoutDlc cpts={cpts} />
        <DefalutCpts cpts={cpts} />
        <Dlcs cpts={cpts} />
      </Accordion>
    </div>
  )
}
const Dlcs = ({ cpts }) => {
  const { tid } = useParams()
  const { data, isLoading } = useSWR(['/dlcs', { tid }], fetcher)
  if (isLoading) return <Loader />
  if (!data) return null
  return (
    <>
      {data?.map((dlc, idx) => (
        <CptsInDlc
          key={dlc.id}
          dlc={dlc}
          cpts={cpts}
          isLast={idx === data.length - 1}
        />
      ))}
    </>
  )
}
